import { render, staticRenderFns } from "./ModalSkill.vue?vue&type=template&id=bd17ec44&scoped=true&"
import script from "./ModalSkill.vue?vue&type=script&lang=js&"
export * from "./ModalSkill.vue?vue&type=script&lang=js&"
import style0 from "./ModalSkill.vue?vue&type=style&index=0&id=bd17ec44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd17ec44",
  null
  
)

export default component.exports